module.exports = __webpack_public_path__ + "img/laboratorio5_4-3_1536.57d7e827.webp";